export default "__VITE_ASSET__DuJSuOrr__"